import { section } from '@settings/common';

const newSection = {
  ...section,
  fields: (section?.fields || []).filter(
    (field) => field.name !== 'bgColor' && field.name !== 'color'
  ),
};

export function Schema() {
  return {
    category: 'Product',
    label: 'Product',
    key: 'product',
    previewSrc:
      'https://cdn.shopify.com/s/files/1/0822/0439/3780/files/product-preview.jpg?v=1721419443',
    fields: [
      {
        name: 'product',
        component: 'productSearch',
        label: 'Product',
        description:
          'The product must be both active and on the Hydrogen sales channel to display',
      },
      newSection,
    ],
  };
}
